import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BackGroundColor from '../../helpers/backgroundColors';
import BackGroundStyles from '../../helpers/backgroundStyles';
import ContentAlignmentSelector from '../../helpers/contentAlignmentSelector';
import './GridColumn.style.scss';

const styleHelper = new BackGroundStyles();
const colorPicker = new BackGroundColor();
const contentAlignmentSelector = new ContentAlignmentSelector();

const getBackgroundStyle = (bg) => {
  const { image, imageOptions = {} } = bg;

  return {
    backgroundImage: image.replace(/"/g, '\''),
    backgroundSize: (imageOptions.isSize_Cover) ? 'center/cover' : '',
    backgroundRepeat: (imageOptions.isNoRepeat) ? 'no-repeat' : 'repeat'
  };
};

const getColumnSize = (opts, children, channel) => {
  const {
    options,
    isGridColumn1,
    isSectionColumn1,
    isSectionColumn2,
    isSectionColumn11,
    isSectionColumn12
  } = opts;
  let sizeString = '';

  if (channel === 'mobile') {
    if (typeof options.size !== 'undefined') {
      sizeString = [
        (options.size.defaultValue) ? ` col-${options.size.defaultValue}` : ' '
      ].join().replace(/,/g, '');
    }
  } else if (channel === 'desktop') {
    if (typeof options.size !== 'undefined') {
      if (isGridColumn1) {
        sizeString = [
          (options.size.defaultValue) ? ` col__${options.size.defaultValue}` : ' ',
        ].join().replace(/,/g, '');
      } else {
        sizeString = [
          (options.size.defaultValue) ? ` col__${options.size.defaultValue}` : ' ',
          (options.size.xs) ? ` col__${options.size.xs}--xs` : ' ',
          (options.size.sm) ? ` col__${options.size.sm}--sm` : ' ',
          (options.size.md) ? ` col__${options.size.md}--md` : ' ',
          (options.size.lg) ? ` col__${options.size.lg}--lg` : ' ',
        ].join().replace(/,/g, '');
      }
    }
  }
  return sizeString;
};
/**
 * @group Layout
 * Displays column component
 */

const GridColumn = (props) => {
  const {
    opts,
    children,
    channel,
    isCategory
  } = props;
  const { options, isSectionColumn11 } = opts;
  if (channel === 'mobile' && options.hideMobile) return null;

  const background = options.background || {};
  const styles = background.image ? getBackgroundStyle(background) : {};
  const columnSize = getColumnSize(opts, children, channel);
  const columnAlignment = contentAlignmentSelector.get(options.contentAlignment);
  const backgroundColor = background.color ? `${background.color}-bg` : '';
  let bgColor = (background.bgPicker) ? colorPicker.get(background.bgPicker) : backgroundColor;

  const gridClass = classNames(
    'grid-column',
    columnSize,
    {
      spad: options.spad,
      alpha: options.alpha,
      omega: options.omega,
      bottomBorder: options.bottomBorder,
      'Vertical-Align--center': (!options.contentAlignment && options.vAlignCenter),
      'no-children': children.length > 0 && children[0].props.opts.type === 'guidedNavigationSlot',
    },
    bgColor,
    columnAlignment,
    'recursive-content'
  );

  return (
    <div
      className={gridClass}
      style={styles}
      id={opts.id}
    >
      {children}
    </div>
  );
};

GridColumn.propTypes = {
  children: PropTypes.instanceOf(Array),
  channel: PropTypes.oneOf([
    'desktop',
    'mobile'
  ]),
  isCategory: PropTypes.bool,
  opts: PropTypes.shape({
    id: PropTypes.string,
    /* This name comes from Etch */
    isSectionColumn11: PropTypes.bool,
    options: PropTypes.shape({
      alpha: PropTypes.bool,
      background: PropTypes.object,
      bottomBorder: PropTypes.bool,
      contentAlignment: PropTypes.shape({}),
      omega: PropTypes.bool,
      size: PropTypes.shape({
        defaultValue: PropTypes.string,
        lg: PropTypes.string,
        md: PropTypes.string,
        sm: PropTypes.string,
        xl: PropTypes.string,
        xs: PropTypes.string
      }),
      spad: PropTypes.bool,
      vAlignCenter: PropTypes.bool,
      hideMobile: PropTypes.bool,
    })
  })

};

GridColumn.defaultProps = {
  children: [],
  channel: 'desktop',
  isCategory: false,
  opts: {
    options: {},
    isSectionColumn11: false
  }
};

export default GridColumn;
